import { _ as __rest, a as __assign } from '../../tslib.es6-2259bcab.js';
import { c as classNames } from '../../index-444bb648.js';
import * as React from 'react';
import { s as skeletonStyles } from '../../skeleton.module-454f2b7a.js';

var styles = {"radioButton":"RadioButton_radioButton_ab6ecb14","largeVariant":"RadioButton_largeVariant_ab6ecb14","label":"RadioButton_label_ab6ecb14","input":"RadioButton_input_ab6ecb14","checked":"RadioButton_checked_ab6ecb14","inputSkeleton":"RadioButton_inputSkeleton_ab6ecb14","largeInput":"RadioButton_largeInput_ab6ecb14","focus-visible":"RadioButton_focus-visible_ab6ecb14","readonly":"RadioButton_readonly_ab6ecb14","labelTextSkeleton":"RadioButton_labelTextSkeleton_ab6ecb14"};

var RadioButton = React.forwardRef(function RadioButton(props, ref) {
    var _a, _b, _c;
    var id = props.id, label = props.label, name = props.name, value = props.value, className = props.className, isSkeleton = props.isSkeleton, isChecked = props.isChecked, onChange = props.onChange, _d = props.variant, variant = _d === void 0 ? "default" : _d, otherProps = __rest(props, ["id", "label", "name", "value", "className", "isSkeleton", "isChecked", "onChange", "variant"]);
    var readonly = !onChange;
    return (React.createElement("label", { className: classNames(styles.radioButton, className, (_a = {},
            _a[styles.readonly] = readonly,
            _a[styles.labelSkeleton] = isSkeleton,
            _a[styles.largeVariant] = variant === "large",
            _a)), "data-testid": "radio-".concat(id) },
        React.createElement("input", __assign({ id: id, value: value || id, ref: ref, type: "radio", name: name || "radio", "aria-busy": isSkeleton, className: classNames(styles.input, (_b = {},
                _b[skeletonStyles.skeleton] = isSkeleton,
                _b[styles.inputSkeleton] = isSkeleton,
                _b[styles.largeInput] = variant === "large",
                _b[styles.checked] = isChecked,
                _b)), checked: isChecked, "aria-checked": isChecked, onChange: onChange, readOnly: readonly }, otherProps)),
        React.createElement("span", { className: classNames(styles.label, (_c = {},
                _c[skeletonStyles.skeleton] = isSkeleton,
                _c[styles.labelTextSkeleton] = isSkeleton,
                _c)), "data-testid": "radio-label" }, label)));
});

export { RadioButton };
